import { Component, inject } from '@angular/core';
import { AppConfig } from '@app/core/app.config';
import { AbstractInlineEditComponent } from '@app/shared/components/inline-edit/inline-edit.component';

@Component({
    selector: 'inline-edit-client',
    templateUrl: './inline-edit-client.component.html',
    styleUrls: ['./inline-edit.component.scss'],
    standalone: false
})
export class InlineEditClientComponent extends AbstractInlineEditComponent {
  protected appConfig = inject(AppConfig);
}
